export const UPDATE_BALANCE = 'DEKS_UPDATE_BALANCE';
